import util from '@/util'

export default { // 状态对象
    isLogged: localStorage.getItem('isLogged') === 'true',                      //  是否已登录
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),             // 用户信息
    userCompanyInfo: JSON.parse(localStorage.getItem('userCompanyInfo') || '{}'), // 当前登录用户公司信息
    adminSelectedCompany: JSON.parse(localStorage.getItem('adminSelectedCompany') || '{}'), // admin登录后选择的公司信息
    mobilePrefix: '+65',            // 手机号前缀
    chatWin: null,                  // chat窗口对象
    collapseMenu: true,            // 左侧菜单是否收起
    chatUnread: 0,                  // chat未读数
    noticeUnread: 0,
    noticeId: null,
    noticeIdAll: null,
    helperNoticeUnread: 0,
    contractNoticeUnread: 0,
    helperWithdrawUnread: 0,
    notificationList: [],
    isDisabledAccount: false,
    // eslint-disable-next-line
    isMobile: /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Honor|Symbian|Windows Phone/i.test(navigator.userAgent),    // 是否为手机端
    isMobileHideMenu: false, // 是手机并且需要隐藏左侧菜单
    scheduleTaskEditLock: JSON.parse(localStorage.getItem('scheduleLock') || 'null'),
    locale: 'en', // i18n语言
    showAgencyGuide: false, // 是否显示agency guid弹窗
    completeAgencyGuide: 0, // 完成agency guid
    browserName: util.getBrowserName(), // 浏览器类型
}
